import { Outlet } from "react-router-dom";
import Sidebar from "./Dashboard/Sidebar";
import "../styles/sidebar.css";
import Footer from "./../components/Footer"; // adjust the path as needed

const DashboardLayout = () => {
  return (
    <div className="d-flex flex-column min-vh-100" style={{ direction: "rtl" }}>
      {/* Main row holds sidebar + main */}
      <div className="d-flex flex-row-reverse flex-grow-1">
        {/* Sidebar - fixed or fixed-width layout */}
        <div
          className="bg-dark text-white vh-100 position-fixed"
          style={{ width: "200px", right: 0, top: 120 }}
        >
          <Sidebar />
        </div>

        {/* Main content */}
        <main className="flex-grow-1" style={{ marginRight: "200px", padding: "1rem" }}>
          <div className="container-fluid">
            <Outlet />
          </div>
        </main>
      </div>
{/* 
      <footer className="bg-dark text-white text-center py-3 mt-auto" dir="rtl">
        <div className="container">
          <h5>پژوهشکده فناوری رهینو</h5>
          <p style={{ fontSize: "14px" }}>
              در شرایط کنونی جهان، پیشرفت در علم و فناوری به‌عنوان محرک توسعه همه‌جانبه محسوب می‌شود به‌طوری که اگر کشوری بخواهد از عقب‌ماندگی فاصله بگیرد، باید به علم و فناوری اهتمام خاص داشته باشد.
              از الزامات سیاست‌گذاری موفق، اشراف به وضعیت کنونی علم و فناوری و رصد دائمی آن در داخل کشور و دیگر کشورهاست؛ به‌طوری‌که این رصدخانه علم و فناوری، توانایی لازم حرکت علم و فناوری از وضع موجود به وضع مطلوب را فراهم می‌آورد.
            </p>
          <p className="fw-bold">پشتیبانی: rahino.observatory@gmail.com</p>
        </div>
      </footer> */}
    </div>
  );
};

export default DashboardLayout;
